module.exports = __webpack_public_path__ + "2d9fa4fc59cf46ad9088540bee9ffe2f.pdf";